$(function(){
$(window).load(function(){
  $('body').addClass('loaded');
});
  
var windowSize = $(window).width();
  if (windowSize < 768) {
		$('#ss-block ul').slick({
			autoplay: true,
			dots: true,
			centerMode: true,
			arrows: false,
			centerPadding: '6%',
			slidesToShow: 1,
			speed: 1000,
          autoplaySpeed: 5000
		});
  } else {
		$('#ss-block ul').slick({
			autoplay: true,
			dots: true,
			centerMode: true,
			arrows: false,
			centerPadding: '0',
			slidesToShow: 1,
			speed: 1000,
          autoplaySpeed: 5000
		});
  }
  
});

// accordion
$(function () {
	var targetHash = window.location.hash;

	$(".label_irreg").each(function () {
		$(this).addClass("open");
		$(this).next().slideDown(0);
	});

	if (targetHash) {
		var $targetDiv = $(targetHash);

		if ($targetDiv.length) {
			var $detail = $targetDiv.closest(".detail");
			var $label = $detail.prev(".label");
			var $labelIrreg = $detail.prev().prev(".label_irreg");

			if ($label.length) {
				$label.addClass("open");
				$label.next().slideDown();
			} else if ($labelIrreg.length) {
				$labelIrreg.addClass("open");
				$labelIrreg.next().slideDown();
			}
			$("html, body").animate(
				{
					scrollTop: $targetDiv.offset().top - 120,
				},
				500,
			);
		}
	}

	$(".label").on("click", function () {
		$(this).next().slideToggle();
		$(this).toggleClass("open");
	});

	$(".label_irreg").on("click", function () {
		if ($(this).hasClass("open")) {
			$(this).removeClass("open");
			$(this).next().slideUp();
		} else {
			$(this).addClass("open");
			$(this).next().slideDown();
		}
	});
});